

var K2kAddressLib = {
  
  getAddressArr : function(customer_id,callback_success,callback_complete)
  {
    //alert("get_k2k_address_list");
    $.ajax
    ({
      type		: "GET",
      url		: _extapi_url + "?action=get_k2k_address_list&customer_id=" + customer_id,
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {

        if(jsonData.result_code == "S0000")
        {
          console.log(jsonData.result_data);


          if(callback_success != null)
          {
            var k2k_addr_list = jsonData.result_data;
            callback_success(k2k_addr_list);
          }
        }
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        alert("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + XMLHttpRequest.responseText + "\n" +
              "text status : " + textStatus + "\n" +
              "error : " + errorThrown);

      },
      complete : function(){
        if(callback_complete != null)
          callback_complete();
      }

    });   
  },

  createAddress : function(customer_id,addr_info, callback_success,callback_complete,callback_error)
  {

    $.ajax
    ({
      type		: "POST",
      url		: _extapi_url,
      data		:
      {
        action: "create_k2k_address",
        customer_id : customer_id,
        zip: addr_info.zip,
        address1: addr_info.address1,
        address2: addr_info.address2,
        province: addr_info.province,
        city: addr_info.city,
        last_name : addr_info.last_name,
        first_name : addr_info.first_name,
        phone : addr_info.phone,
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
//_console_log(jsonData);
        if(jsonData.result_code == "S0000")
        {
          if(callback_success != null) callback_success(jsonData.result_data);
        }
		else
        {
          alert(jsonData.result_msg);
        }

      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        alert("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + XMLHttpRequest.responseText + "\n" +
              "text status : " + textStatus + "\n" +
              "error : " + errorThrown);
        if(callback_error != null) callback_error();
        
      },
      complete : function(){
        if(callback_complete != null) callback_complete();
      }
    });  
  },

  updateAddress : function(customer_id,addr_info, callback_success,callback_complete,callback_error)
  {

    $.ajax
    ({
      type		: "POST",
      url		: _extapi_url,
      data		:
      {
        action: "update_k2k_address",
        customer_id : customer_id,
        addr_no:addr_info.addr_no,
        zip: addr_info.zip,
        address1: addr_info.address1,
        address2: addr_info.address2,
        province: addr_info.province,
        city: addr_info.city,
        last_name : addr_info.last_name,
        first_name : addr_info.first_name,
        phone : addr_info.phone,
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
//_console_log(jsonData);
        if(jsonData.result_code == "S0000")
        {
          if(callback_success != null) callback_success(jsonData.result_data);
        }


      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        alert("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + XMLHttpRequest.responseText + "\n" +
              "text status : " + textStatus + "\n" +
              "error : " + errorThrown);
        if(callback_error != null) callback_error();
        
      },
      complete : function(){
        if(callback_complete != null) callback_complete();
      }
    });  
  },
  addAddress : function(customer_id,addr_info, callback_success,callback_complete,callback_error)
  {

    $.ajax
    ({
      type		: "POST",
      url		: _extapi_url,
      data		:
      {
        action: "add_k2k_address",
        customer_id : customer_id,
        zip: addr_info.zip,
        address1: addr_info.address1,
        address2: addr_info.address2,
        province: addr_info.province,
        city: addr_info.city,
        last_name : addr_info.last_name,
        first_name : addr_info.first_name,
        phone : addr_info.phone,
      },
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {
//_console_log(jsonData);
        if(jsonData.result_code == "S0000")
        {
          if(callback_success != null) callback_success(addr_info);
        }


      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        alert("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + XMLHttpRequest.responseText + "\n" +
              "text status : " + textStatus + "\n" +
              "error : " + errorThrown);
        if(callback_error != null) callback_error();
        
      },
      complete : function(){
        if(callback_complete != null) callback_complete();
      }
    });  
  },
 
  deleteAddress : function(customer_id,k2k_addr_id, callback_success,callback_complete)
  {

    $.ajax
    ({
      type		: "GET",
      url		: _extapi_url + "?action=delete_k2k_address&customer_id=" + customer_id + "&k2k_addr_id=" + k2k_addr_id,
      cache		: false,
      dataType	: "json",
      async		: true,
      success		: function(jsonData)
      {

        //_console_log(jsonData);
        if(jsonData.result_code == "S0000")
        {
          if(callback_success != null) callback_success(k2k_addr_id);
        }


      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        alert("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + XMLHttpRequest.responseText + "\n" +
              "text status : " + textStatus + "\n" +
              "error : " + errorThrown);
      },
      complete : function(){
        if(callback_complete != null) callback_complete();
      }
    });  
  },
  
  validateAddress : function(addrObj)
  {

    //_console_log(addrObj);
    if(is_empty(addrObj.phone) || is_empty(addrObj.zip) 
       || is_empty(addrObj.address1) || is_empty(addrObj.address2) || is_empty(addrObj.address2.trim())  
       || is_empty(addrObj.province) 
       || is_empty(addrObj.last_name) || is_empty(addrObj.first_name))
    {
      alert("입력사항을 모두 기입해주세요.");
      return false;
    }

    // 기존 번호에서 - 를 삭제합니다.
    var trans_num = addrObj.phone.replace(/-/gi,'');

    // 입력값이 있을때만 실행합니다.
    if(trans_num != null && trans_num != '')
    {
      // 총 핸드폰 자리수는 11글자이거나, 10자여야 합니다.
      if(trans_num.length==11 || trans_num.length==10 || trans_num.length==9) 
      {   
        // 유효성 체크
        var regExp_ctn = /^(010|02|0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
        if(regExp_ctn.test(trans_num))
        {
           return true;
        }
        else {
          if(trans_num.startsWith("011") || trans_num.startsWith("016") || trans_num.startsWith("017") || trans_num.startsWith("018")){
            alert("휴대전화 앞번호는 010으로 통합되었습니다. 다시 확인 후 입력해주세요.");
            return false;
          }
        }
      }
    }

    alert("입력하신 전화번호가 유효하지않습니다.");
    return false;
  }


}

